<woa-modal-page-layout [title]="'woa.heading.order-details.title'">
    <woa-order-details-panel class="order-details" [recentOrder]="recentOrder()"></woa-order-details-panel>
</woa-modal-page-layout>
